import MergeTags from "./MergeTags";

export default MergeTags;
